// extracted by mini-css-extract-plugin
export default {"robot-icon":"adc__robot-icon--ym_1W","content":"adc__content--dZC1A"};